<template>
  <section class="border-b border-slate-200 bg-slate-50 py-12">
    <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div class="text-center">
        <p class="text-xs font-black uppercase tracking-[0.16em] text-blue-700">
          Tecnologias disponíveis
        </p>

        <h2 class="mt-2 text-2xl font-black text-[#071a3d]">
          Encontre a solução adequada para seu uso
        </h2>
      </div>

      <div class="mt-8 grid grid-cols-2 gap-4 md:grid-cols-4">
        <div
          v-for="item in items"
          :key="item"
          class="flex min-h-20 items-center justify-center rounded-2xl border border-slate-200 bg-white px-4 text-center font-black text-slate-700 shadow-sm"
        >
          {{ item }}
        </div>
      </div>

      <p
        class="mx-auto mt-6 max-w-3xl text-center text-xs leading-5 text-slate-500"
      >
        Empresa independente. As marcas mencionadas pertencem aos seus
        respectivos proprietários.
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
const items = ["Windows", "Microsoft Office", "Windows Server", "Autodesk"];
</script>
